import React from "react";
import { View } from "react-native";
import { styles } from "./Message.styles";
import { Icon } from "../Icon/Icon";
import { Text } from "../Text/Text";
const typeMap = {
    info: {
        icon: "attention",
        color: "greyscale",
    },
    warn: {
        icon: "attention",
        color: "warning",
    },
    success: {
        icon: "tick",
        color: "positive",
    },
    error: {
        icon: "attention",
        color: "negative",
    },
};
export const Message = ({ children, styles: userStyles, type, color: userColor, icon: userIcon, small, background, ...rest }) => {
    const color = !userColor && type ? typeMap[type].color : userColor || "greyscale";
    const icon = !userIcon && type ? typeMap[type].icon : userIcon || "attention";
    const size = !small ? "medium" : "small";
    const fontSize = !small ? "base" : "xsmall2";
    const IconComponent = Icon[(icon.charAt(0).toUpperCase() + icon.slice(1))];
    return (React.createElement(View, { accessibilityRole: "alert", style: [styles.defaults, background && styles.background, userStyles], ...rest },
        React.createElement(View, { style: styles.icon },
            React.createElement(IconComponent, { size: size, color: color })),
        React.createElement(Text, { fontSize: fontSize, style: [styles[color]] }, children)));
};
//# sourceMappingURL=Message.js.map